import React from 'react'

const CreditInfo = ({config, isLoggedIn = false, onLoginClick, tokenInfo = null}) => {
    // Show loading until tokenInfo is loaded (don't show intermediate config values)
    const isLoading = tokenInfo === null

    // Use tokenInfo from API if available, otherwise use config
    const remainingTokens = tokenInfo
        ? tokenInfo.remaining || tokenInfo.remainingTokens || 0
        : config?.dailyFreeCredit || 0

    const totalCredits = tokenInfo
        ? tokenInfo.total || tokenInfo.totalTokens || config?.dailyFreeCredit || 0
        : config?.dailyFreeCredit || 0

    const isOutOfCredits = remainingTokens === 0

    return (
        <div className="d-flex justify-content-between align-items-center">
            <div className="credit-info">
                <div className="credit-count">
                    <p className={`${isOutOfCredits ? 'text-danger' : ''} fw-medium`} style={isOutOfCredits ? {color: '#0A7B91'} : {}}>
                        {isLoading ? 'Loading...' : `${remainingTokens}/${totalCredits} daily credit`}
                    </p>
                </div>
                {!isLoggedIn && (
                    <div className="d-flex align-items-center gap-2">
                        <div className="credit-line"></div>
                        <button type="button" className="login-now-link text-primary" onClick={onLoginClick}>
                            Log in now
                        </button>
                        <p>to grab your free credits for today!</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default CreditInfo

